export default __webpack_public_path__ + "assets/02n.4aca209b.svg";